import React, {
	Component
} from 'react';
import ReactDOM from 'react-dom';
//import "./ScheduleBlock.css"; //css goes here ;)
import diff from 'deep-diff';
// let kuiScheduler = window.kendo;
import $ from 'jquery';
import kendo from '@progress/kendo-ui';

export default class KendoScheduler extends Component {
	createScheduler(newOptions) {
		var elementNode = ReactDOM.findDOMNode(this);
		elementNode.id = "kendo-scheduler";
		//determine if a selector was passed on which to invoke the KUI widget
		if (this.props.selector) {
			elementNode = elementNode.querySelector(this.props.selector);
		}

		if (this.widgetInstance) {
			this.widgetInstance.destroy();
			$(ReactDOM.findDOMNode(this))
				.empty();
		}
		//instantiate and save reference to the Kendo UI widget on elementNode
		//note I am not using jQuery plugin to instantiate, don't want to wait for namespace on $.fn
		if (newOptions) {
			this.widgetInstance = new kendo.ui.Scheduler(elementNode,
				newOptions);
		} else {

			this.widgetInstance = new kendo.ui.Scheduler(elementNode, this.props
				.options);
		}

		//if props are avaliable for events, triggers, unbind events, or methods make it happen now
	}
	//component is in the DOM, so do stuff to it in this callback
	componentDidMount() {
		//get, child element node for this component
		this.createScheduler();
		
	}

	//instance methods for updating widget
	triggerKendoWidgetEvents(events) {
		events.forEach( (event) => { //loop over events, and trigger
			this.widgetInstance.trigger(event);
		});
	
	}
	bindEventsToKendoWidget(events) {
		Object.keys(events)
			.forEach( (event)=> { //loop over events and bind
				this.widgetInstance.bind(event, events[event]);
			});
	}
	unbindEventsToKendoWidget(events) {
		events.forEach( (event)=> { //loop ove revents and unbind
			this.widgetInstance.unbind(event);
		});
	}
	callKendoWidgetMethods(methods) {
		Object.keys(methods)
			.forEach( (method)=> { //loop over methods and call
				this.widgetInstance[method](...methods[method]);
			});
	}

	//not called on inital render, but whenever parent state changes this is called
	componentWillReceiveProps(nextProps) {
				
		//always update the widget with nextProp changes if avaliable
		if (nextProps.events) {
			this.bindEventsToKendoWidget(nextProps.events);
			
		}

		if (nextProps.options) {

			// let old instance =this.widgetInstance.destroy();
			// $(ReactDOM.findDOMNode(this))
			// 	.empty();
			// let diff1 = diff(nextProps.options.resources[0].dataSource, this.props.options.resources[0].dataSource);
			// let diff2 = diff(nextProps.options.resources[1].dataSource, this.props.options.resources[1].dataSource);
			// let diff3 = diff(nextProps.options.resources[2].dataSource, this.props.options.resources[2].dataSource);
			// let diff4 = diff(nextProps.options.resources[3].dataSource, this.props.options.resources[3].dataSource);
			let diff5 = diff(nextProps.options.dataSource, this.props.options.dataSource);
			if (diff5) {
				this.createScheduler(nextProps.options);
			}
			// this.widgetInstance.setOptions(nextProps.options);
		}

	}

	//don't run render again, create widget once, then leave it alone
	shouldComponentUpdate() {
		return false;
	}

	//destory it, when the component is unmouted
	componentWillUnmount() {
		this.widgetInstance.destroy();
	}

	//use the passed in React nodes or a plain <div> if no React child nodes are defined
	render() {
		return this.props.children ? this.props.children : <div />;
	}
}



// WEBPACK FOOTER //
// ./src/Utilities/KendoScheduler/index.js